import * as React from 'react';

import { Icon } from '@material-ui/core';

import { IProps } from './interfaces';

import styles from './InlineError.module.styl';

export const InlineError = (props: IProps) => (
  <div className={styles.root}>
    <Icon className={styles.icon}>error</Icon>
    {props.children}
  </div>
);
